<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-tight py-6">
        <div class="text-center mb-5 mb-4 mt-4">
          <a href="."
            ><img
              :src="require('../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <div class="card card-md">
          <div class="card-body text-center">
            <h3 class="align-items-center">{{ msg }}</h3>
          </div>
        </div>
        <div class="text-center text-muted mt">
          <router-link to="/login">登入</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: this.$route.params.token,
      msg: "",
    };
  },
  methods: {
    async emailVerfiy() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/email/verify`;
      try {
        const res = await this.$http.patch(api, { token: this.token });
        if (res.data.data) {
          this.msg = "Email 地址 驗證成功";
        } else {
          this.msg = "錯誤，重複驗證";
        }
      } catch (err) {
        this.msg = "Email 地址 驗證失敗";
      }
    },
  },
  created() {
    this.emailVerfiy();
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}
</style>

